<template>
  <AuthLayout
    eyebrow="Anmeldung"
    title="Kundenbereich"
    intro=""
    card-title="Willkommen zurück"
    card-intro="Melden Sie sich an oder legen Sie in wenigen Schritten ein neues Konto an."
    :aside-list="[
      'Vermarktung aller Art von Unterkünften',
      'Vermarktung von Events',
      'Vermarktung besonderer Orte',
      'Vermarktung von touristischen Angeboten',
      'Verwaltung Ihrer Medien und Inhalte',
      'Verwaltung Ihrer Webseite',
      'Auswertungen & Statistiken',
    ]"
    :compact-stage="true"
    :show-mobile-brand="true"
    footnote=""
  >
    <div class="auth-login-panel">
      <form class="user auth-form-stack" @submit.prevent="login(constants.PROVIDERS.manet, $event)">
        <div v-if="noticeMessage" class="alert alert-info py-2" role="status">
          {{ noticeMessage }}
        </div>
        <div class="form-floating mb-3">
          <input v-model="loginIdentifier" id="login" name="login" placeholder="E-Mail oder Kundennummer" class="form-control" type="text" autocomplete="username"/>
          <label for="login">E-Mail oder Kundennummer</label>
        </div>

        <div class="form-floating mb-3">
          <input v-model="password" id="password" name="password" placeholder="Passwort" type="password"
                 class="form-control"/>
          <label for="password">Passwort</label>
        </div>
        <MatchaWidget v-model="matchaToken" />
        <div v-if="loginError" class="alert alert-danger py-2" role="alert">
          {{ loginError }}
        </div>
        <button type="submit" class="btn btn-primary btn-block">
          Anmelden
        </button>
        <div class="auth-form-divider">oder</div>
        <button
          type="button"
          class="btn btn-outline-secondary btn-block d-flex align-items-center justify-content-center border"
          @click="login(constants.PROVIDERS.google, $event)"
        >
          <Icon icon="flat-color-icons:google" class="me-2" />
          Mit Google anmelden
        </button>
      </form>

      <div class="auth-switch">
        <p class="auth-switch__text">
          <span class="auth-switch__label">Noch kein Konto?</span>
          Erstellen Sie Ihr Konto und starten Sie direkt mit Ihrem Vermarktungswunsch.
        </p>
        <router-link :to="{name: 'register'}" class="btn btn-outline-secondary btn-block border auth-switch__cta">
          Jetzt registrieren
        </router-link>
      </div>

      <div class="auth-switch">
        <p class="auth-switch__text">
          <span class="auth-switch__label">Passwort vergessen?</span>
          Fordern Sie einen Wiederherstellungslink an, um Ihr Passwort sicher zurückzusetzen.
        </p>
        <router-link :to="{name: 'forgot_password'}" class="btn btn-outline-secondary btn-block border auth-switch__cta">
          Passwort zurücksetzen
        </router-link>
      </div>
    </div>
  </AuthLayout>
</template>


<script>
import {useUserStore} from "@/stores/user";
import * as constants from '@/stores/constants'
import AuthLayout from "@/components/layout/AuthLayout.vue";
import MatchaWidget from "@/components/auth/MatchaWidget.vue";
import {matchaError} from "@/scripts/matcha";
export default {
  name: "Login",
  components: {
    AuthLayout,
    MatchaWidget
  },
  setup() {
    const userStore = useUserStore()
    return {userStore}
  },
  data() {
    return {
      loginIdentifier: '',
      password: '',
      loginError: '',
      matchaToken: '',
      constants
    }
  },
  computed: {
    noticeMessage() {
      const noticesByKey = {
        session_expired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
        impersonation_expired: 'Die bisherige Impersonation wurde sicher beendet. Bitte melden Sie sich erneut an.',
        password_changed: 'Ihr Passwort wurde geändert. Bitte melden Sie sich mit dem neuen Passwort an.',
      }
      return noticesByKey[this.$route.query.notice] || ''
    },
  },
  methods: {
    login(provider, e) {
      e.preventDefault();
      if(provider === constants.PROVIDERS.manet) {
        this.loginError = ''
        this.userStore.login(provider, this.loginIdentifier, this.password, this.matchaToken).catch((error) => {
          if (matchaError(error)) {
            this.loginError = matchaError(error)
            return
          }
          if (error?.response?.status === 401) {
            this.loginError = 'E-Mail/Kundennummer oder Passwort ist nicht korrekt.'
            return
          }
          this.loginError = 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.'
        })
      } else {
        this.loginError = ''
        this.userStore.externalAuth(provider).catch(() => {
          this.loginError = 'Die Google-Anmeldung ist zurzeit nicht verfügbar. Bitte versuchen Sie es erneut.'
        })
      }
    }
  },
}
</script>

<style scoped lang="scss">
.auth-login-panel {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.auth-form-stack {
  display: flex;
  flex-direction: column;
}

.auth-form-divider {
  margin: 1.25rem 0 0.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(12, 58, 83, 0.12);
  color: #6f8799;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-align: center;
  text-transform: uppercase;
}

.auth-switch {
  padding-top: 0.25rem;
  border-top: 1px solid rgba(12, 58, 83, 0.12);
  text-align: center;
}

.auth-switch__label {
  display: block;
  margin-bottom: 0.4rem;
  color: #6f8799;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.auth-switch__text {
  max-width: 22rem;
  margin: 1rem auto 1.25rem;
  color: #5f7283;
  font-size: 0.95rem;
  line-height: 1.55;
}

.auth-switch__cta {
  margin: 0;
}
</style>
